import { CtrlCollection, CtrlType } from '@yuigoto/ctrl';
import { Col } from 'components/grid/Col';
import { Row } from 'components/grid/Row';
import { ControlRenderer } from 'components/renderers/ControlRenderer';
import { CampaignControl } from 'controls/CampaignControl';
import { ExecuteRequest } from 'core/glambox/GlamboxApi';
import { GlamboxEndpoints } from 'core/glambox/GlamboxEndpoints';
import React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { UiActions } from 'state/actions/UiActions';
import { PartnerAdminActions } from 'state/actions/user/PartnerAdminActions';
import Styles from 'views/pages/DadosPessoais.module.scss';

export class CreateCampaign extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      challengeRules: '',
      challengeDescription: '',
      products: [],
      campaignProducts: [],
      statusList: [],
      campaignStatus: null,
      paymentTypes: [],
      productVariantIds: [],
    };
    this.collection = new CtrlCollection();

    for (let i in CampaignControl) {
      if (Array.isArray(CampaignControl[i])) {
        let tempCollection = new CtrlCollection();

        for (let n in CampaignControl[i]) {
          tempCollection.add(CampaignControl[i][n]);
        }

        this.collection.collection.push(tempCollection);
      } else {
        this.collection.add(CampaignControl[i]);
      }
    }
  }

  componentDidMount() {
    const { history, person } = this.props;

    this.props.isAdmin(person.person.username, response => {
      const isAdmin = response.result;
      if (!isAdmin) {
        history.push('/');
      }
    });

    this.getPaymentTypes();
    this.getCampaignStatus();
  }

  getPaymentTypes = async () => {
    await ExecuteRequest(
      GlamboxEndpoints.GlampartnerPaymentRegistry.getPaymentTypesDetail,
      null,
      'GET',
      {
        Authorization: this.props.token,
      },
      null,
      response => {
        const { result, statusCode } = response;
        if (statusCode === 200) {
          this.setState(
            {
              paymentTypes: result,
            },

            () => {
              this.renderPaymentTypeList();
            }
          );
        }
      }
    );
  };

  renderPaymentTypeList = () => {
    let { paymentTypes } = this.state;
    if (!paymentTypes) return null;

    let paymentTypeControl = this.collection.get('influencerPaymentTypeId'),
      opts = [];
    for (let paymentType of paymentTypes) {
      opts.push({
        name: `${
          paymentType.influencerPaymentTypeId
        } - ${paymentType.description.trim()}`,
        value: paymentType.influencerPaymentTypeId,
      });
    }

    paymentTypeControl.options = opts;
    paymentTypeControl.onChange = (_, value) => {
      let paymentTypeControl = this.collection.get('paymentDescription');
      let comission = null;
      let paymentType = null;

      for (let payment of paymentTypes) {
        if (payment.influencerPaymentTypeId === parseInt(value)) {
          comission = payment.value;
          paymentType = parseInt(value);
        }
      }

      paymentTypeControl.value = paymentType.description || null;

      let paymentTypeComissionControl = this.collection.get('value');
      paymentTypeComissionControl.value = comission;

      this.renderChallengeField(value);
      this.forceUpdate();
    };
    this.forceUpdate();
  };

  renderChallengeField = paymentType => {
    const isChallengeType = paymentType === 12;

    const mainVideo = this.collection.get('mainVideo');
    const firstTutorialVideo = this.collection.get('firstTutorialVideo');
    const secondTutorialVideo = this.collection.get('secondTutorialVideo');
    const thirdTutorialVideo = this.collection.get('thirdTutorialVideo');
    const bannerMobile = this.collection.get('bannerMobile');
    const bannerDesktop = this.collection.get('bannerDesktop');
    const rules = this.collection.get('rules');
    const resume = this.collection.get('resume');
    const product = this.collection.get('product');
    const description = this.collection.get('description');

    product.type = isChallengeType ? CtrlType.HIDDEN : CtrlType.DEFAULT;
    description.type = isChallengeType ? CtrlType.HIDDEN : CtrlType.DEFAULT;

    mainVideo.type = isChallengeType ? CtrlType.DEFAULT : CtrlType.HIDDEN;
    firstTutorialVideo.type = isChallengeType
      ? CtrlType.DEFAULT
      : CtrlType.HIDDEN;
    secondTutorialVideo.type = isChallengeType
      ? CtrlType.DEFAULT
      : CtrlType.HIDDEN;
    thirdTutorialVideo.type = isChallengeType
      ? CtrlType.DEFAULT
      : CtrlType.HIDDEN;
    bannerMobile.type = isChallengeType ? CtrlType.DEFAULT : CtrlType.HIDDEN;
    bannerDesktop.type = isChallengeType ? CtrlType.DEFAULT : CtrlType.HIDDEN;
    rules.type = isChallengeType ? CtrlType.TEXTAREA : CtrlType.HIDDEN;
    resume.type = isChallengeType ? CtrlType.TEXTAREA : CtrlType.HIDDEN;

    product.required = !isChallengeType;
    description.required = !isChallengeType;

    mainVideo.required = isChallengeType;
    bannerMobile.required = isChallengeType;
    bannerDesktop.required = isChallengeType;
    rules.required = isChallengeType;
    resume.required = isChallengeType;
  };

  getCampaignStatus = () => {
    ExecuteRequest(
      GlamboxEndpoints.Campaign.getStatus,
      null,
      'GET',
      { Authorization: this.props.token },
      null,
      response => {
        const { result, statusCode } = response;

        if (statusCode === 200) {
          this.setState({
            campaignStatus: result,
          });

          this.renderStatusList();
        }
      }
    );
  };

  renderStatusList = () => {
    let { campaignStatus } = this.state;
    let statusTotais = {};

    for (let status of campaignStatus) {
      statusTotais[status.statusId] = status.statusName.trim();
    }

    this.setState(
      {
        statusList: statusTotais,
      },
      () => {
        let statusControl = this.collection.get('statusId'),
          opts = [];
        for (let status of campaignStatus) {
          opts.push({
            name: `${status.statusId} - ${status.statusName.trim()}`,
            value: status.statusId,
          });
        }

        statusControl.options = opts;
        statusControl.onChange = (evt, value) => {
          let statusIdControl = this.collection.get('statusName');
          const statusName = campaignStatus.find(item => {
            return item.statusId === parseInt(value);
          });
          statusIdControl.value = statusName.statusName || null;
          this.forceUpdate();
        };
        this.forceUpdate();
      }
    );
  };

  renderOptions = (props, options) => {
    return (
      <select
        onChange={e => props.onChange(e.target.value)}
        value={props.value}
      >
        {(() => {
          return options.map((value, key) => {
            return (
              <option value={value} key={key}>
                {value}
              </option>
            );
          });
        })()}
      </select>
    );
  };

  onSubmit = e => {
    e.preventDefault();
    this.buildCampaignRequestBody(campaignRequestBody => {
      this.createCampaign(campaignRequestBody);
    });
  };

  buildCampaignRequestBody = callback => {
    if (this.collection.validate()) {
      let campaignData = this.collection.toObject(true);
      campaignData.members = parseInt(campaignData.members);
      campaignData.payment = parseFloat(campaignData.payment);

      let dateFrom = new Date(
        campaignData.dateFrom.split('/').reverse().join('-') + 'T00:00:00'
      );

      let dateTo = new Date(
        campaignData.dateTo.split('/').reverse().join('-') + 'T00:00:00'
      );

      let finishDate = new Date(
        campaignData.finishDate.split('/').reverse().join('-') + 'T00:00:00'
      );

      campaignData.dateFrom = dateFrom;
      campaignData.dateTo = dateTo;
      campaignData.finishDate = finishDate;

      const isChallengeType = campaignData.paymentType === 12;
      if (isChallengeType) {
        campaignData.description = '';
        campaignData.product = '';
      }

      callback(campaignData);
    } else {
      this.forceUpdate();
    }
  };

  createCampaign = campaignRequestBody => {
    this.props.loaderShow();
    ExecuteRequest(
      GlamboxEndpoints.Campaign.create,

      Object.assign({}, campaignRequestBody),
      'POST',
      {
        Authorization: this.props.token,
      },
      null,
      response => {
        const { statusCode, result } = response;

        if (statusCode === 200) {
          this.props.publishSuccessAlert('Campanha criada com sucesso');
        } else {
          this.props.publishErrorAlert(result.message);
        }
        this.props.loaderHide();
      }
    );
  };

  render() {
    return (
      <div className={'p-2 p-lg-5'}>
        <Helmet>
          <title>Admin Campanha : Criar Campanha</title>
        </Helmet>
        <h1>Criar campanha</h1>
        <Row>
          <Col xs={12} md={6}>
            <div className={'gb-contentblock p-4 level-2 mb-2'}>
              <form onSubmit={this.onSubmit}>
                {ControlRenderer.renderCollection(this.collection)}

                <div className={Styles['info__buttons']}>
                  <button className={'btn btn-light-pink btn-md'}>
                    Salvar
                  </button>
                </div>
              </form>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  store: state,
  token: state.token.data.Authorization,
  person: state.person.data,
});

const mapDispatchToProps = dispatch => ({
  loaderShow: () => {
    dispatch(UiActions.loaderShow());
  },
  loaderHide: () => {
    dispatch(UiActions.loaderHide());
  },
  publishSuccessAlert: message => {
    dispatch(UiActions.publishSuccessAlert(message));
  },
  publishErrorAlert: message => {
    dispatch(UiActions.publishErrorAlert(message));
  },
  isAdmin: (email, callback) => {
    dispatch(PartnerAdminActions.isAdmin(email, callback));
  },
});

CreateCampaign = connect(mapStateToProps, mapDispatchToProps)(CreateCampaign);
